var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseAuthoritiesManageOfEvent',{key:_vm.versionkeyreload,attrs:{"AuthoritiesManageOfEvent":_vm.payload,"entrycode":_vm.entrycode,"passed":true}})}
var staticRenderFns = []

export { render, staticRenderFns }